export const MODULE_ID = {
  DEFAULT: 'default',
  DECOMP_INSIGHTS: 'decomp-insights',
  NETFLOW: 'netflow',
  ALERTS: 'alerts',
  SCENARIO_PLANNER: 'scenario-planner',
  SCENARIO_PLANNER_DETAILS: 'scenario-planner-details',
};
